import React, { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { Row, Col } from "antd";
import { Link } from "react-router-dom";

import Container from "../../modules/contact/containers/List";
import withPage from "./withPage";
import UploadForm from "../Forms/Contacts/Upload";
import RoutePlanCurrent from "../RoutePlan/RoutePlanCurrent";
import { getTranslation } from "../../utils/helper";
import "./OrdersUpload.scss";
import SettingMenu from "../Menu/SettingMenu";
import "./ContactLocationsUpload.scss";

const ContactLocationsUploadPage = ({ action, isFetching, status, doUploadContacts, history, query }) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;
  const [settingType, setSettingType] = useState("contact-list/upload");
  const [match, setMatch] = useState(false);

  useEffect(() => {
    if (action === "upload" && status === "succeeded") {
      history.push("/settings/contact-list");
    }
  }, [isFetching]);

  return (
    <div className="Content SettingsPage">
      <RoutePlanCurrent />
      <div className="ContentMain">
        <Row gutter={16}>
          <Col span={6}>
            <SettingMenu
              history={history}
              setting={setting}
              settingType={settingType}
              setSettingType={setSettingType}
            />
          </Col>
          <Col span={18}>
            <div className="SettingContent">
              <div className="Content OrdersUploadPage ContactLocationsUploadPage">
                <div className="ContentHeader">
                  <div className="HeaderTitle">
                    <Link to={"/settings/contact-list"}>{getTranslation(setting, "Contacts", "Contacts")}</Link>
                    <ReactSVG className="icon" src="/icons/arrow-forward.svg" />
                    <span className="Link">{getTranslation(setting, "Contacts", "Upload New Contacts")}</span>
                    {match && (
                      <>
                        <ReactSVG className="icon" src="/icons/arrow-forward.svg" />
                        <span className="Link">{getTranslation(setting, "Contacts", "Match Header Data")}</span>
                      </>
                    )}
                  </div>
                </div>
                <div className="ContentMain">
                  <UploadForm
                    isFetching={isFetching}
                    setMatch={setMatch}
                    doUploadContacts={doUploadContacts}
                    query={query}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default withPage(Container(ContactLocationsUploadPage));
